import { getPricingsEndpoint } from '@api/fetchers/checkout';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import { useEffect } from 'react';

const usePricings = ({ goalUID }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const {
    data: pricings,
    mutate,
    ...rest
  } = useFetch(getPricingsEndpoint(goalUID), {
    useCamelCase: false
  });

  useEffect(() => {
    if (isLoggedIn) {
      mutate();
    }
  }, [isLoggedIn, mutate]);

  return { pricings, mutate, ...rest };
};

export default usePricings;
